/* import __COLOCATED_TEMPLATE__ from './preview-content-card.hbs'; */
import Component from '@glimmer/component';
export default class PreviewContentCard extends Component {}